import actions from "./actions";
import state from "./states";
import mutations from "./mutations";

const AdminPopupModule = {
  namespaced: true,
  actions,
  state,
  mutations,
};

export default AdminPopupModule;